import styled from "styled-components";

const Anchor = styled.a`
	color: var(--anchor-text-color);
	cursor: pointer;
	user-select: none;
`;

export default Anchor;
